import { AuthShell } from "@/components/AuthShell";
import React from "react";
import { useNavigate } from "react-router-dom";

import { useAppStore } from "@/store/appStore";

const OidcCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const { setSession } = useAppStore();
  const [message, setMessage] = React.useState("Completing sign-in...");
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code") || "";
      const state = params.get("state") || "";
      const providerError = params.get("error") || "";
      const providerErrorDescription = params.get("error_description") || "";

      if (providerError) {
        setError(providerErrorDescription || providerError);
        return;
      }
      if (!code || !state) {
        setError("Missing code or state from identity provider");
        return;
      }
      try {
        const res = await fetch("/api/v1/auth/oidc/callback", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, state }),
        });
        const body = await res.json();
        if (!res.ok) throw new Error(String(body?.detail || "OIDC callback failed"));
        setSession(String(body.access_token || ""), String(body.refresh_token || ""));
        setMessage("Sign-in successful. Redirecting...");
        const returnTo = String(body.return_to || "/");
        navigate(returnTo.startsWith("/") ? returnTo : "/", { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : "OIDC callback failed");
      }
    };
    void run();
  }, [navigate, setSession]);

  return <AuthShell title="Single Sign-On" message={message} error={error || undefined} />;
};

export default OidcCallbackPage;
